import { getLabelFallback } from '@utils/utils';
import { ReactElement, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import * as actions from "@redux-actions/";
import { preparePayment, submitPayment } from '@utils/services';
import { useNavigate, useLocation } from 'react-router';
import { convertNumber, handleHTTPError } from '@utils/utils';
import ApplePay from '@images/svg-icons/apple_pay.svg';

import ApplePayButton from './ApplePayButton';

type ApplePayCardProps = {
  expressCheckout: boolean,
};



const ApplePayCard = (props: ApplePayCardProps): ReactElement => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { search } = useLocation();
  const { expressCheckout } = props;

  const isMobile = useSelector(state => state.cart.isMobile);
  const config = useSelector(state => state.cart.config);
  const cart = useSelector(state => state.cart.cart);

  const [applePayLogged, setApplePayLogged] = useState(false);

  const label = getLabelFallback('APPLE_TEXT_LABEL_PART1').replace(
    '{SITE_NAME}',
    getLabelFallback('SITE_NAME')
  );

  const orderId =
    config.onBehalfSession === true && !!cart && !!cart.orderId ? { orderId: cart.orderId } : {};

  useEffect(() => {
    if (
      !!cart &&
      !!cart.paymentInstruction &&
      cart.paymentInstruction.length > 0 &&
      cart.paymentInstruction[0].payMethodId === 'ApplePay'
    ) {
      setApplePayLogged(true);
      dispatch(actions.setEmail(cart.orderItem[0].email1));
    } else {
      setApplePayLogged(false);
    }
  }, [cart]);

  const content = !applePayLogged ? (
    isMobile ? (
      <span
        dangerouslySetInnerHTML={{
          __html: (

            label +
              ' ' +
              getLabelFallback('APPLE_TEXT_LABEL_PART2')
                .replace(
                  '{TERM_AND_CONDITION_APPLE}',
                  '<a class="primary-button" target="_blank" aria-label="' +
                    getLabelFallback('TERM_AND_CONDITION_APPLE') +
                    '" href="' +
                    config.linkTermCondition +
                    '">' +
                    getLabelFallback('TERM_AND_CONDITION_APPLE') +
                    '</a>'
                )
                .replace(
                  '{PRIVACY_POLICY_APPLE}',
                  '<a class="primary-button" target="_blank" aria-label="' +
                    getLabelFallback('PRIVACY_POLICY_APPLE') +
                    '" href="' +
                    config.linkPrivacyPolicy +
                    '">' +
                    getLabelFallback('PRIVACY_POLICY_APPLE') +
                    '</a>'
                )
          ),
        }}
      ></span>
    ) : (
      <>
        <span>{label}</span>
        <span
          dangerouslySetInnerHTML={{
            __html: (
              getLabelFallback('APPLE_TEXT_LABEL_PART2')
                .replace(
                  '{TERM_AND_CONDITION_APPLE}',
                  '<a class="primary-button" target="_blank" aria-label="' +
                    getLabelFallback('TERM_AND_CONDITION_APPLE') +
                    '" href="' +
                    config.linkTermCondition +
                    '">' +
                    getLabelFallback('TERM_AND_CONDITION_APPLE') +
                    '</a>'
                )
                .replace(
                  '{PRIVACY_POLICY_APPLE}',
                  '<a class="primary-button" target="_blank" aria-label="' +
                    getLabelFallback('PRIVACY_POLICY_APPLE') +
                    '" href="' +
                    config.linkPrivacyPolicy +
                    '">' +
                    getLabelFallback('PRIVACY_POLICY_APPLE') +
                    '</a>'
                )
            ),
          }}
        ></span>
      </>
    )
  ) : (
    <>
      <span>
        {getLabelFallback('APPLE_ACCOUNT_LABEL').toUpperCase()}{' '}
        {!!cart &&
          !!cart.paymentInstruction &&
          cart.paymentInstruction.lenght > 0 &&
          cart.paymentInstruction[0].email1}
      </span>
      <span>
        {getLabelFallback('APPLE_AMOUT_LABEL').toUpperCase()}: {getLabelFallback('CURRENCY_LABEL')}
        {convertNumber(cart.grandTotal)}
      </span>
    </>
  );

  const cta = !applePayLogged ? (
   <ApplePayButton expressCheckout={expressCheckout} smartGlassesError={null}/>
  ) : 
    // <MainButton
    //   type="button"
    //   onClick={e => doPayment(e)}
    //   label={getLabelFallback('APPLE_CONFIRM_PAYMENT_LABEL')}
    // />
    <button aria-label={getLabelFallback('APPLE_CONFIRM_PAYMENT_LABEL')} className="violet-button" onClick={(e) => doPayment(e)}>{getLabelFallback('APPLE_CONFIRM_PAYMENT_LABEL')}</button>;
  ;

  const doPayment = e => {
    if(!!e && e !== undefined) {
      e.preventDefault();
    }
    preparePayment(config.hostname, orderId)
      .then((res: any) => {
        if (res.status === 200) {
          const submitPaymnetData = {
            orderId: cart.orderId,
            notifyOrderSubmitted: '1',
            notifyMerchant: '1',
            notifyShopper: '1',
            notify_EMailSender_recipient: '',
            purchaseorder_id: '',
          };

          submitPayment(config.hostname, submitPaymnetData)
            .then((res: any) => {
              dispatch(actions.setOrderId(res.data.orderId));
              window.sessionStorage.removeItem('insertStorePreferred');
              if(typeof $TB != 'undefined' && !!$TB.hooks) {
                $TB.hooks.fireEvent("pageChange", null, {"sendBeacon": true});
              }
              navigate(config.pagesUrl.typ + search);
            })
            .catch(err => {
              console.error(
                '>>> Apple Pay submit payment => error status:',
                err.status,
                ', error: ',
                err
              );
              handleHTTPError(dispatch, actions, err);
              dispatch(actions.errorLoading());
            });
        }
      })
      .catch(err => {
        console.error('>>> Apple Pay prepare payment => error status:', err.status, ', error: ', err);
        handleHTTPError(dispatch, actions, err);
        dispatch(actions.errorLoading());
      });
  };

  return (
    <div className="applepay-card">
      {/* <div className="applepay-card-top">{content}</div> */}
      <div className="applepay-card-bottom">{cta}</div>
    </div>
  );
};

export default ApplePayCard;
